import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PoUiModule } from './../../../shared/po-ui/po-ui.module';
import { LoadingComponent } from './loading.component';


@NgModule({
  declarations: [
    LoadingComponent
  ],
  imports: [
    CommonModule,
    PoUiModule
  ],
  exports: [
    LoadingComponent
  ]
})
export class LoadingModule { }
